import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../../theme/generated/tokens';

export const paginatorTheme: ThemeOptions['components'] = {
  DsPaginator: {
    styleOverrides: {
      root: ({ theme, ownerState: { size } }) => ({
        display: 'inline-flex',
        alignItems: 'center',
        color: tokens.theme.fg.structural.secondary,
        ...(size === 'sm'
          ? {
              height: 24,
              ...theme.typography.P12R,
            }
          : { height: 28, ...theme.typography.P14R }),
      }),
      icon: {
        color: 'inherit',
      },
      text: { lineHeight: 1, marginRight: 18 },
    },
  },
};
